import { render, staticRenderFns } from "./NewImageUploader.vue?vue&type=template&id=3b48d949"
import script from "./NewImageUploader.vue?vue&type=script&lang=js"
export * from "./NewImageUploader.vue?vue&type=script&lang=js"
import style0 from "./NewImageUploader.vue?vue&type=style&index=0&id=3b48d949&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/template/components/NewImageUploader.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FVolumes%2FSSD%2Fjenkins_workspace%2Fworkspace%2FJL_UAT_MPORTAL%2Fsrc%2Fcomponents%2FNewImageUploader.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports